import script from "./EsgReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EsgReportPage.vue?vue&type=script&setup=true&lang=js"

import "./EsgReportPage.vue?vue&type=style&index=0&id=a0adfb6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0adfb6e"]])

export default __exports__